import { useIntl } from 'react-intl'
import { useEffect, useMemo, useState } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { useWindowResize, LuxBreadcrumb, LuxButton, Color } from '@lux/wardrobe-lib'
import {
    layoutActions,
    filtersActions,
    ability,
    SmartlyActionItems,
    SmartlyActionTypes,
} from '@Techedge/digitalportal-shared'
import Header from '../components/Layout/Header/Header'
import Sidebar from '../components/Layout/Sidebar/SideBar'
import MainContent from '../components/Layout/MainContent/MainContent'
import ActiveFilters from '../components/Filters/ActiveFilters/ActiveFilters'
import FilterCategories from '../components/Filters/FilterCategories/FilterCategories'
import FilterSubCategories from '../components/Filters/FilterSubCategories/FilterSubcategories'
import { FILTERS_REDUCER_NAMESPACE } from '@redux/reducers/filters'
import {
    getAllSubtypes,
    getDepartments,
    getActivityFiltersOptions,
    getRecipients,
    doApplyFilter,
    showToastEmptyFilterWarning,
    showToastSaveFilterSuccess,
    showToastSaveFilterFailure,
    getReportTimes,
    setSelectedTimeCluster,
    getMacroareas,
    getPhotoStatusList,
    getFiltersActivityTypes,
    getFiltersDomain,
} from '../redux/actions/filters'
import RoundedButton from '../components/UI/RoundedButton/RoundedButton'
import TextButton from '../components/UI/TextButton/TextButton'
import CardModal from '../components/UI/CardModal/CardModal'
import OutlinedButton from '../components/UI/OutlinedButton/OutlinedButton'
import SavingFilters from '../components/Filters/SavingFilters/SavingFilters'
import {
    FilterSubCategoriesProjectTypeOptions,
    FilterSubCategoriesStatusOptions,
} from '@components/Filters/FilterSubCategoryItem/FilterSubCategoryItem'
import { FiltersService } from '@services/FiltersService'
import {
    Filter,
    FilterCategory,
    FilterCategoryType,
    ID_ORIGINAL_FILTER_FE,
    StepPage,
    TypeOfSubcategory,
} from '@models/filters'
import Distribution from '../components/ActivityCreation/Distribution/DistributionList'
import { DistributionListProps } from '@models/new-resource'
import PhotoTagsSelect from '../components/Gallery/PhotoTagsSelect'
import SpecialCollectionsMultiselect from '../components/Gallery/SpecialCollectionsMultiselect'
import './Filters.scss'
import {
    getFilterFromSmartFilter,
    getFilterFromStoreFilter,
    getSmartFilterForDistribution,
} from '@utils/storeFilterAdapter'
import { DISTRIBUTION_REDUCER_NAMESPACE } from '../redux/reducers/distribution'
import { NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE } from '../redux/reducers/activity-creation'

const Filters = (props: any) => {
    const {
        closeFilters,
        userFilters,
        storesOptionList,
        storeIdList,
        setSelectedTimeCluster,
        statusOptionList,
        getFiltersActivityTypes,
        selectedTimeCluster,
        projectTypeOption,
        activityTypes,
        getMacroareas,
        macroareas,
        user,
        getFiltersDomain,
        filtersOptionsMap,
        doApplyFilter,
        getDepartments,
        getFilterStatusOptions,
        getRecipients,
        getPhotoStatusList,
        setLoading,
        banner,
    } = props

    const intl = useIntl()

    const isMobile = useWindowResize()

    const [filterCategorySelected, setFilterCategorySelected] = useState<FilterCategoryType>()
    const [idFilterSelected, setIdFilterSelected] = useState(ID_ORIGINAL_FILTER_FE)
    const [showConfirmModal, setShowConfirmModal] = useState(false)
    const [showSavingFilter, setShowSavingFilter] = useState(false)
    const [smartFilter, setSmartFilter] = useState({})
    const [storeFilters, setStoreFilters] = useState({}) // filtri applicati componente distribution senza smart filters
    const [previousAppliedFilters, setPreviousAppliedFilters] = useState(undefined) // filtri salvati dall'utente

    const [EMPTY_FILTER, setEmptyFilter] = useState<Filter>({
        ...new Filter(ID_ORIGINAL_FILTER_FE),
        name: intl.formatMessage({
            id: 'modals.active_saved_filters.original_filter',
            defaultMessage: 'Original filter',
        }),
        isOriginalFilter: true,
    })

    const [localEditedFilter, setLocalEditedFilter] = useState<Filter>(EMPTY_FILTER)
    const [distributionList, setDistributionList] = useState<DistributionListProps>({
        listName: {
            value: '',
        },
        selectedStoreList: {
            value: [],
            mandatory: true,
        },
        selectedDistributionList: {
            value: [],
        },
    })

    useEffect(() => {
        if (!isMobile) {
            setFilterCategorySelected('PROJECTS')
        }
        fetchFilters()
        getFiltersDomain(() => setLoading(false))
        getDepartments()
        getFiltersActivityTypes()
        getFilterStatusOptions()
        getRecipients()
        getPhotoStatusList()
    }, [])

    useEffect(() => {
        if (!!Object.keys(filtersOptionsMap).length) {
            let existingFilter = userFilters?.find((filter) => filter.isApply)
            existingFilter =
                existingFilter || userFilters?.find((filter) => filter.isOriginalFilter)

            if (!!existingFilter) {
                setIdFilterSelected(existingFilter._id)
                isPreviouslyAppliedFilterSmartFilter(existingFilter)
                    ? setSmartFilter(
                          getSmartFilterForDistribution({
                              ...existingFilter.categories.storeSpecs,
                              banner: existingFilter.categories.storeSpecs.banner.map((b) =>
                                  filtersOptionsMap.bannerObject.find((o) => o.code === b)
                              ),
                          })
                      )
                    : setPreviousAppliedFilters({
                          ...existingFilter.categories.storeSpecs,
                          banner: existingFilter.categories.storeSpecs.banner.map((b) =>
                              filtersOptionsMap.bannerObject.find((o) => o.code === b)
                          ),
                      })
                setDistributionList((dl) => ({
                    ...dl,
                    selectedStoreList: {
                        ...dl.selectedStoreList,
                        value: existingFilter.categories.storeSpecs.store.map((sId) => ({
                            store_id: sId,
                        })),
                    },
                }))
                return
            }

            const defaultFilter = userFilters?.find((filter) => filter.isDefault)

            if (!!defaultFilter) {
                setIdFilterSelected(defaultFilter._id)
                return
            }
        }
    }, [filtersOptionsMap, userFilters])

    //check se i filtri precedentemente salvati dall'utente siano smart o normali
    const isPreviouslyAppliedFilterSmartFilter = (filter: Filter) => {
        const hasStoreList: boolean = filter.categories.storeSpecs.store.length > 0
        if (hasStoreList) {
            return false
        }
        let hasOtherKeysValued: boolean = false
        Object.keys(filter.categories.storeSpecs).forEach((filterKey) => {
            hasOtherKeysValued =
                hasOtherKeysValued || filter.categories.storeSpecs[filterKey].length > 0
        })
        return hasOtherKeysValued
    }

    const fetchFilters = () => {
        props.getFilters()
    }

    const currentStep = useMemo<StepPage>(() => {
        if (showSavingFilter) {
            return 'SAVING_FILTER'
        }

        if (filterCategorySelected) {
            return 'CATEGORY_SELECTED'
        }

        return 'SELECT_CATEGORY'
    }, [showSavingFilter, filterCategorySelected])

    const isSelectCategoryStep = currentStep === 'SELECT_CATEGORY'
    const isCategorySelectedStep = currentStep === 'CATEGORY_SELECTED'
    const isSavingFilterStep = currentStep === 'SAVING_FILTER'

    const componentClass = 'smart-modals-filters'

    const activityBreadcrumb = [
        {
            id: '0',
            label: intl.formatMessage({
                id: 'modals.filters.breadcrumbs.filter',
                defaultMessage: 'Filter',
            }),
        },
        ...(showSavingFilter
            ? [
                  {
                      id: '1',
                      label: intl.formatMessage({
                          id: 'modals.filters.label.save_filter',
                          defaultMessage: 'Save Filter',
                      }),
                  },
              ]
            : []),
    ]

    const [currentFilterSelected, setCurrentFilterSelected] = useState<any>()
    useEffect(() => {
        const filterSelected = userFilters?.find((filter) => filter._id === idFilterSelected) ?? {}
        if (!!filterSelected._id && filterSelected._id !== ID_ORIGINAL_FILTER_FE) {
            setCurrentFilterSelected(filterSelected)
            return
        }
        setCurrentFilterSelected({ ...EMPTY_FILTER, isOriginalFilter: true, _id: idFilterSelected })
    }, [idFilterSelected])

    useEffect(() => {
        let _filters = { ...localEditedFilter }

        if (!!_filters.categories) {
            _filters.categories.storeSpecs.store = distributionList.selectedStoreList.value?.map(
                (r) => r.store_id
            )
            setLocalEditedFilter(_filters)
        }
    }, [distributionList.selectedStoreList.value])

    useEffect(() => {
        //Returning to the Filters main page from the Saving Filter page, editedFilter is repopulated with "original filter"
        if (!showSavingFilter) {
            setLocalEditedFilter(currentFilterSelected)
        }
    }, [JSON.stringify(currentFilterSelected), showSavingFilter])

    const changeEditedFilterField = (value: any, pathKey: string) => {
        let oldFilter = _.cloneDeep(localEditedFilter)
        _.set(oldFilter, pathKey, value)
        if (pathKey === 'categories.project.status') {
            _.set(
                oldFilter,
                'categories.project.overdue',
                value.activity.length === 1 && value.activity[0] === 'overdue'
            )
        }
        setLocalEditedFilter(oldFilter)
    }

    const clearLocaleEditedFilter = () => {
        setLocalEditedFilter({ ...EMPTY_FILTER, isOriginalFilter: true })
    }

    const isStatusChanged = () => {
        return (
            localEditedFilter?.categories?.project?.status.activity.length !==
            statusOptionList.length
        )
    }
    const isTypeChanged = () => {
        let selectedValues
        if (localEditedFilter?._id) {
            selectedValues = activityTypes.reduce((acc, curr) => {
                return (
                    acc +
                    (
                        localEditedFilter?.categories?.project?.type[curr] ||
                        projectTypeOption.activity?.filter((o) => o.value.split('_')[0] === curr)
                    )?.length
                )
            }, 0)
        }
        return selectedValues !== projectTypeOption.activity?.length
    }
    const isRecipientChanged = () => {
        return (
            localEditedFilter?.categories?.project?.referenceUser.length !==
            props.recipientList.length
        )
    }
    const isDepartmentChanged = () => {
        return (
            localEditedFilter?.categories?.project?.departement.length !==
            props.departmentList.length
        )
    }
    const isPriorityChanged = () => {
        return (
            localEditedFilter?.categories?.project?.priority.length !==
            props.prioritiesOptionList.length
        )
    }

    const isProjectTitleChanged = () => {
        return Boolean(localEditedFilter?.categories?.project?.projectTitle)
    }

    const projectCategoryShowBadge = useMemo(() => {
        return (
            isStatusChanged() ||
            isTypeChanged() ||
            isRecipientChanged() ||
            isDepartmentChanged() ||
            isPriorityChanged() ||
            isProjectTitleChanged()
        )
    }, [localEditedFilter])

    const storeSpecsCategoryShowBadge = (spec: string) => {
        return (
            localEditedFilter?.categories?.storeSpecs[spec]?.length !==
            storesOptionList[spec]?.length
        )
    }

    const storeSpecsStoreShowBadge = () => {
        if (!localEditedFilter) return false
        const filterStoreLength = localEditedFilter.categories.storeSpecs.store?.length
        return (
            (filterStoreLength > 0 && filterStoreLength < storeIdList.length) ||
            (!filterStoreLength &&
                !!Object.values(localEditedFilter.categories.storeSpecs).filter((f) => !!f.length)
                    .length)
        )
    }

    const onChangeReportsTiming = (newVal: string) => {
        setSelectedTimeCluster(newVal)
    }

    const getCurrentWeekFirstDay = (d: Date) => {
        // 👇️ clone date object, so we don't mutate it
        let date = new Date(d)
        let day = date.getDay() // 👉️ get day of week
        // 👇️ day of month - day of week (-6 if Sunday), otherwise +1
        let diff = date.getDate() - day + (day === 0 ? -6 : 1)
        return new Date(date.setDate(diff))
    }

    const getFirstDayOfMonth = (year, month) => {
        return new Date(year, month, 1)
    }

    const getLastDayOfMonth = (year, month) => {
        return new Date(year, month + 1, 0)
    }

    useEffect(() => {
        if (selectedTimeCluster) {
            let from = undefined
            let to = undefined
            let today = new Date()
            let currentWeekFirstDay = getCurrentWeekFirstDay(today)
            let currentWeekLastDay = new Date(currentWeekFirstDay)
            currentWeekLastDay.setDate(currentWeekLastDay.getDate() + 6)
            let lastWeekFirstDay = new Date(currentWeekFirstDay)
            lastWeekFirstDay.setDate(lastWeekFirstDay.getDate() - 7)
            let lastWeekLastDay = new Date(currentWeekLastDay)
            lastWeekLastDay.setDate(lastWeekLastDay.getDate() - 7)
            let currentMonthFirstDay = getFirstDayOfMonth(
                new Date().getFullYear(),
                today.getMonth()
            )
            let currentMonthLastDay = getLastDayOfMonth(new Date().getFullYear(), today.getMonth())
            let lastMonthFirstDay = getFirstDayOfMonth(
                new Date().getFullYear(),
                today.getMonth() - 1
            )
            let lastMonthLastDay = getLastDayOfMonth(new Date().getFullYear(), today.getMonth() - 1)
            let currentYear = new Date().getFullYear()
            let currentYearFirstDay = new Date(currentYear, 0, 1)
            let currentYearLastDay = new Date(currentYear, 11, 31)
            let lastYear = currentYear - 1
            let lastYearFirstDay = new Date(lastYear, 0, 1)
            let lastYearLastDay = new Date(lastYear, 11, 31)
            switch (selectedTimeCluster) {
                case 'last_week':
                    from = lastWeekFirstDay.getTime()
                    to = lastWeekLastDay.getTime()
                    break
                case 'last_month':
                    from = lastMonthFirstDay.getTime()
                    to = lastMonthLastDay.getTime()
                    break
                case 'last_year':
                    from = lastYearFirstDay.getTime()
                    to = lastYearLastDay.getTime()
                    break
                case 'current_week':
                    from = currentWeekFirstDay.getTime()
                    to = currentWeekLastDay.getTime()
                    break
                case 'current_month':
                    from = currentMonthFirstDay.getTime()
                    to = currentMonthLastDay.getTime()
                    break
                case 'current_year':
                    from = currentYearFirstDay.getTime()
                    to = currentYearLastDay.getTime()
                    break
                case 'year_to_date':
                    from = currentYearFirstDay.getTime()
                    to = today.getTime()
                    break
                case 'none':
                default:
                    break
            }
            setLocalEditedFilter({
                ...localEditedFilter,
                categories: {
                    ...localEditedFilter?.categories,
                    timeFrame: {
                        ...localEditedFilter?.categories?.timeFrame,
                        from: from,
                        to: to,
                    },
                },
            })
        }
    }, [selectedTimeCluster])

    const timeFrameCategoryShowBadge =
        !!localEditedFilter?.categories?.timeFrame?.from &&
        !!localEditedFilter?.categories?.timeFrame.to

    const photoSpecsCategoryShowBadge =
        !!localEditedFilter?.categories?.photoSpecs?.status?.length ||
        !!localEditedFilter?.categories?.photoSpecs?.macroAreas?.length ||
        !!localEditedFilter?.categories?.photoSpecs?.tags?.length

    const disabledSaveButtons = !(
        projectCategoryShowBadge ||
        storeSpecsCategoryShowBadge ||
        timeFrameCategoryShowBadge ||
        photoSpecsCategoryShowBadge
    )

    const getFilterForApi = (newFilter) => {
        const newStoresOption = { ...storesOptionList }
        newStoresOption.macroregion = storesOptionList.macroRegion
        // newStoresOption.store = storesList
        delete newStoresOption.macroRegion
        delete newStoresOption.stores
        delete newFilter.categories.storeSpecs.coneOfVision
        return {
            ...newFilter,
            categories: {
                ...newFilter.categories,
                project: {
                    ...newFilter.categories.project,
                    status: {
                        activity:
                            newFilter.categories.project.status.activity.length !==
                            statusOptionList.length
                                ? newFilter.categories.project.status.activity
                                : [],
                    },
                    type: {
                        ...(activityTypes.reduce((acc, curr) => {
                            const tmp = { ...acc }
                            tmp[curr] =
                                newFilter.categories.project.type[curr]?.length ===
                                projectTypeOption.activity?.filter((t) => t.value.includes(curr))
                                    .length
                                    ? undefined
                                    : newFilter.categories.project.type[curr]
                            return { ...tmp }
                        }, {}) as any),
                    },
                    referenceUser:
                        newFilter.categories.project.referenceUser.length !==
                        props.recipientList.length
                            ? newFilter.categories.project.referenceUser
                            : [],
                    departement:
                        newFilter.categories.project.departement.length !==
                        props.departmentList.length
                            ? newFilter.categories.project.departement
                            : [],
                    priority:
                        newFilter.categories.project.priority.length !==
                        props.prioritiesOptionList.length
                            ? newFilter.categories.project.priority
                            : [],
                },
                storeSpecs: {
                    ...newFilter.categories.storeSpecs,
                    ...Object.keys(newFilter.categories.storeSpecs).reduce((acc, curr) => {
                        const tmp = { ...acc }
                        tmp[curr] =
                            newFilter.categories.storeSpecs[curr]?.length !==
                            newStoresOption[curr]?.length
                                ? newFilter.categories.storeSpecs[curr]?.map((o) => o.value || o)
                                : []
                        return { ...tmp }
                    }, {}),
                },
            },
        }
    }

    const getDefaultStatusOption = () => {
        return {
            activity: statusOptionList?.map((s) => s.value),
        }
    }
    const getDefaultRecipientOption = () => {
        return [...props.recipientList?.map((s) => s.value)]
    }
    const getDefaultDepartmentOption = () => {
        return [...props.departmentList?.map((s) => s.value)]
    }
    const getDefaultPriorityOption = () => {
        return [...props.prioritiesOptionList?.map((s) => s.value)]
    }
    const getDefaultProjectTypeOption = (projectTypeOption) => {
        if (!projectTypeOption?.activity) return {}
        const res = activityTypes.reduce((acc, curr) => {
            return {
                ...acc,
                [curr]: (projectTypeOption.activity || [])
                    ?.filter((t) => t.value.includes(curr))
                    .map((t) => t.value.split('_')[1]),
            }
        }, {})
        return res
    }

    const resetStatusOption = () => {
        const newFilter = { ...currentFilterSelected }
        newFilter.categories.project.status = getDefaultStatusOption()
        setLocalEditedFilter(newFilter)
    }
    const resetProjectTypeOption = () => {
        const newFilter = { ...currentFilterSelected }
        newFilter.categories.project.type = getDefaultProjectTypeOption(projectTypeOption)
        setLocalEditedFilter(newFilter)
    }
    const resetRecipientOption = () => {
        const newFilter = { ...currentFilterSelected }
        newFilter.categories.project.referenceUser = getDefaultRecipientOption()
        setLocalEditedFilter(newFilter)
    }
    const resetDepartmentOption = () => {
        const newFilter = { ...currentFilterSelected }
        newFilter.categories.project.departement = getDefaultDepartmentOption()
        setLocalEditedFilter(newFilter)
    }
    const resetPriorityOption = () => {
        const newFilter = { ...currentFilterSelected }
        newFilter.categories.project.priority = getDefaultPriorityOption()
        setLocalEditedFilter(newFilter)
    }

    useEffect(() => {
        if (currentFilterSelected && currentFilterSelected._id) {
            const newFilter = { ...currentFilterSelected }
            newFilter.categories.project.status =
                currentFilterSelected._id === ID_ORIGINAL_FILTER_FE ||
                !newFilter.categories.project.status.activity.length
                    ? getDefaultStatusOption()
                    : newFilter.categories.project.status
            newFilter.categories.project.type =
                currentFilterSelected._id === ID_ORIGINAL_FILTER_FE ||
                !Object.keys(newFilter.categories.project?.type || {}).length
                    ? getDefaultProjectTypeOption(projectTypeOption)
                    : newFilter.categories.project.type
            newFilter.categories.project.departement =
                currentFilterSelected._id === ID_ORIGINAL_FILTER_FE ||
                !newFilter.categories.project.departement.length
                    ? getDefaultDepartmentOption()
                    : newFilter.categories.project.departement
            newFilter.categories.project.referenceUser =
                currentFilterSelected._id === ID_ORIGINAL_FILTER_FE ||
                !newFilter.categories.project.referenceUser.length
                    ? getDefaultRecipientOption()
                    : newFilter.categories.project.referenceUser
            newFilter.categories.project.priority =
                currentFilterSelected._id === ID_ORIGINAL_FILTER_FE ||
                !newFilter.categories.project.priority.length
                    ? getDefaultPriorityOption()
                    : newFilter.categories.project.priority
            setLocalEditedFilter(newFilter)
            if (currentFilterSelected.isOriginalFilter) {
                setEmptyFilter(newFilter)
            }
        }
    }, [
        statusOptionList,
        projectTypeOption,
        props.departmentList,
        props.recipientList,
        props.prioritiesOptionList,
        currentFilterSelected,
    ])

    useEffect(() => {
        if (banner?.length > 0) {
            getMacroareas(banner)
        }
    }, [banner])

    const photoFilterCategory = user.phase2_enabled
        ? [
              {
                  category: 'PHOTO_SPECS',
                  isActive: filterCategorySelected === 'PHOTO_SPECS',
                  label: intl.formatMessage({
                      id: 'ph2.modals.filters.label.photo_specs',
                      defaultMessage: 'Photo Specs',
                  }),
                  showBadge: photoSpecsCategoryShowBadge,
                  onClick: () => {
                      onPressFilterItem('PHOTO_SPECS')
                  },
                  filterList: [
                      {
                          label: intl.formatMessage({
                              id: 'ph2.modals.filters.label.macroarea',
                              defaultMessage: 'Macro Area',
                          }),
                          type: 'MULTISELECT' as TypeOfSubcategory,
                          listOptions: macroareas,
                          filterPath: 'categories.photoSpecs.macroAreas',
                          filterValue: _.get(localEditedFilter, 'categories.photoSpecs.macroAreas'),
                          showBadge:
                              localEditedFilter?.categories?.photoSpecs?.macroAreas?.length > 0,
                          setFilterValue: (val) =>
                              changeEditedFilterField(val, 'categories.photoSpecs.macroAreas'),
                      },
                      {
                          label: intl.formatMessage({
                              id: 'ph2.modals.filters.label.picture_status',
                              defaultMessage: 'Picture status',
                          }),
                          type: 'MULTISELECT' as TypeOfSubcategory,
                          listOptions: props.photoStatusList?.map((s) => ({
                              label: intl.formatMessage({
                                  id: `ph2.gallery.detail.task_photo.status.${s.label}`,
                                  defaultMessage: s.label,
                              }),
                              value: s.value,
                          })),
                          filterPath: 'categories.photoSpecs.status',
                          filterValue: _.get(localEditedFilter, 'categories.photoSpecs.status'),
                          showBadge: localEditedFilter?.categories?.photoSpecs?.status?.length > 0,
                          setFilterValue: (val) =>
                              changeEditedFilterField(val, 'categories.photoSpecs.status'),
                      },
                      {
                          label: intl.formatMessage({
                              id: 'ph2.modals.filters.label.tags',
                              defaultMessage: 'Tags',
                          }),
                          type: 'CUSTOM' as TypeOfSubcategory,
                          listOptions: macroareas,
                          filterPath: 'categories.photoSpecs.tags',
                          showBadge: localEditedFilter?.categories?.photoSpecs?.tags?.length > 0,
                          customContent: (
                              <PhotoTagsSelect
                                  bannerList={storesOptionList.banner?.map((b) => b.value)}
                                  value={_.get(localEditedFilter, 'categories.photoSpecs.tags')}
                                  onChangeValue={(val) => {
                                      changeEditedFilterField(val, 'categories.photoSpecs.tags')
                                  }}
                              />
                          ),
                      },
                      ...(ability.can(
                          SmartlyActionTypes.CREATE,
                          SmartlyActionItems.ALBUM,
                          'special_collection'
                      )
                          ? [
                                {
                                    label: intl.formatMessage({
                                        id: 'ph2.modals.filters.label.special_collection',
                                        defaultMessage: 'Special collection',
                                    }),
                                    type: 'CUSTOM' as TypeOfSubcategory,
                                    listOptions: macroareas,
                                    filterPath: 'categories.photoSpecs.specialCollection',
                                    showBadge:
                                        localEditedFilter?.categories?.photoSpecs
                                            ?.specialCollections?.length > 0,
                                    customContent: (
                                        <SpecialCollectionsMultiselect
                                            value={_.get(
                                                localEditedFilter,
                                                'categories.photoSpecs.specialCollections'
                                            )}
                                            onChange={(val) => {
                                                changeEditedFilterField(
                                                    val,
                                                    'categories.photoSpecs.specialCollections'
                                                )
                                            }}
                                        />
                                    ),
                                },
                            ]
                          : []),
                  ],
              },
          ]
        : []

    const filterItems: FilterCategory[] = [
        {
            category: 'PROJECTS',
            isActive: filterCategorySelected === 'PROJECTS',
            label: intl.formatMessage({
                id: 'modals.filters.label.projects',
                defaultMessage: 'Projects',
            }),
            showBadge: projectCategoryShowBadge,
            onClick: () => {
                onPressFilterItem('PROJECTS')
            },
            filterList: [
                {
                    //pending the creation of the BE service, static values are used
                    label: intl.formatMessage({
                        id: 'modals.filters.label.status',
                        defaultMessage: 'Status',
                    }),
                    type: 'CUSTOM',
                    filterPath: 'categories.project.status',
                    showBadge: isStatusChanged(),
                    customContent: (
                        <FilterSubCategoriesStatusOptions
                            subCategoryName={intl.formatMessage({
                                id: 'modals.filters.label.status',
                                defaultMessage: 'Status',
                            })}
                            groupOptions={{
                                activity: statusOptionList,
                            }}
                            filterValue={_.get(localEditedFilter, 'categories.project.status')}
                            setFilterValue={(val) => {
                                changeEditedFilterField(val, 'categories.project.status')
                            }}
                            translateLabel={true}
                            onReset={resetStatusOption}
                        />
                    ),
                },
                {
                    label: intl.formatMessage({
                        id: 'modals.filters.label.project_type',
                        defaultMessage: 'Project Type',
                    }),
                    type: 'CUSTOM',
                    filterPath: 'categories.project.type',
                    showBadge: isTypeChanged(),
                    customContent: (
                        <FilterSubCategoriesProjectTypeOptions
                            groupOptions={projectTypeOption}
                            filterValue={_.get(localEditedFilter, 'categories.project.type')}
                            setFilterValue={(val) =>
                                changeEditedFilterField(val, 'categories.project.type')
                            }
                            onReset={resetProjectTypeOption}
                            translateLabel
                            activityTypes={activityTypes}
                        />
                    ),
                },
                {
                    label: intl.formatMessage({
                        id: 'modals.filters.label.reference_user',
                        defaultMessage: 'Reference User',
                    }),
                    type: 'MULTISELECT',
                    listOptions: props.recipientList,
                    filterPath: 'categories.project.referenceUser',
                    filterValue: _.get(localEditedFilter, 'categories.project.referenceUser'),
                    showBadge: isRecipientChanged(),
                    setFilterValue: (val) =>
                        changeEditedFilterField(val, 'categories.project.referenceUser'),
                    translateLabel: true,
                    onReset: resetRecipientOption,
                },
                {
                    label: intl.formatMessage({
                        id: 'modals.filters.label.department',
                        defaultMessage: 'Department',
                    }),
                    type: 'MULTISELECT',
                    translateLabel: true,
                    listOptions: props.departmentList,
                    filterPath: 'categories.project.departement',
                    filterValue: _.get(localEditedFilter, 'categories.project.departement'),
                    showBadge: isDepartmentChanged(),
                    setFilterValue: (val) =>
                        changeEditedFilterField(val, 'categories.project.departement'),
                    onReset: resetDepartmentOption,
                },
                {
                    //pending the creation of the BE service, static values with the correct nomenclature are used
                    label: intl.formatMessage({
                        id: 'modals.filters.label.priority',
                        defaultMessage: 'Priority',
                    }),
                    type: 'MULTISELECT',
                    listOptions: props.prioritiesOptionList,
                    filterPath: 'categories.project.priority',
                    filterValue: _.get(localEditedFilter, 'categories.project.priority'),
                    showBadge: isPriorityChanged(),
                    setFilterValue: (val) =>
                        changeEditedFilterField(val, 'categories.project.priority'),
                    translateLabel: true,
                    onReset: resetPriorityOption,
                },
                {
                    label: intl.formatMessage({
                        id: 'modals.filters.label.favourite',
                        defaultMessage: 'Favourite',
                    }),
                    type: 'SWITCH',
                    filterPath: 'categories.project.favourite',
                    filterValue: _.get(localEditedFilter, 'categories.project.favourite'),
                    setFilterValue: (val) =>
                        changeEditedFilterField(val, 'categories.project.favourite'),
                },
                {
                    label: intl.formatMessage({
                        id: 'modals.filters.label.overdue',
                        defaultMessage: 'Overdue',
                    }),
                    type: 'SWITCH',
                    filterPath: 'categories.project.overdue',
                    filterValue: _.get(localEditedFilter, 'categories.project.overdue'),
                    setFilterValue: (val) => {
                        changeEditedFilterField(
                            val ? { activity: ['overdue'] } : getDefaultStatusOption(),
                            'categories.project.status'
                        )
                    },
                },
            ],
        },
        {
            category: 'STORE_SPECS',
            isActive: filterCategorySelected === 'STORE_SPECS',
            label: intl.formatMessage({
                id: 'modals.filters.label.store_specs',
                defaultMessage: 'Store Specs',
            }),
            showBadge: storeSpecsStoreShowBadge(),
            onClick: () => {
                onPressFilterItem('STORE_SPECS')
            },
            filterList: [
                {
                    label: intl.formatMessage({
                        id: 'modals.filters.label.store',
                        defaultMessage: 'Store List',
                    }),
                    isCollapsed: false,
                    keepOpen: true,
                    filterPath: 'categories.storeSpecs.store',
                    showBadge: storeSpecsStoreShowBadge(),
                    type: 'CUSTOM',
                    customContent: (
                        <Distribution
                            tableConfigId={'new_activity_news'}
                            form={distributionList}
                            onSetForm={(form: any) => {
                                setDistributionList((value: any) => ({
                                    ...value,
                                    ...form,
                                }))
                            }}
                            onSave={() => null}
                            smartFilter={smartFilter || {}}
                            setSmartFilter={setSmartFilter}
                            hideDistributionList
                            setExternalFilters={setStoreFilters}
                            externalFilters={previousAppliedFilters}
                        />
                    ),
                },
            ],
        },
        {
            category: 'TIME_FRAME',
            isActive: filterCategorySelected === 'TIME_FRAME',
            label: intl.formatMessage({
                id: 'modals.filters.label.time_frame',
                defaultMessage: 'Time Frame',
            }),
            showBadge: timeFrameCategoryShowBadge,
            onClick: () => {
                onPressFilterItem('TIME_FRAME')
            },
            filterList: [],
        },
        ...photoFilterCategory,
    ]

    const filterItemsSummary = filterItems
        .filter((filter) => filter.showBadge)
        ?.map((filter) => ({
            ...filter,
            isActive: false,
        }))

    const currentFilterCategoryList =
        filterItems?.find((item) => item.category === filterCategorySelected)?.filterList ?? []

    const handleClose = () => {
        if (showSavingFilter) {
            setShowSavingFilter(false)
        } else if (isMobile && filterCategorySelected) {
            setFilterCategorySelected(null)
        } else {
            closeFilters()
        }
    }

    const showActionButtonIntoMainFooter = useMemo(() => {
        return !!(isMobile && filterCategorySelected)
    }, [isMobile, filterCategorySelected])

    const onClickSaveFilter = async () => {
        let filterId = localEditedFilter?._id
        //Checks if a filter with the same id already exists,
        //if it does then it's called the UpdateFilter service otherwise CreateFilter
        try {
            const response = await FiltersService.CreateFilter({
                ...getFilterForApi(localEditedFilter),
                isOriginalFilter: false,
            })
            filterId = response.data.filterId

            if (localEditedFilter?.isDefault) {
                await FiltersService.SetFavouriteFilter(filterId)
            }

            await props.showToastSaveFilterSuccess()
            fetchFilters()
            setShowSavingFilter(false)
        } catch (error) {
            props.showToastSaveFilterFailure()
        }
    }

    const onClickUpdateFilter = async () => {
        try {
            await FiltersService.UpdateFilter(getFilterForApi(localEditedFilter))
            await props.showToastSaveFilterSuccess()
            fetchFilters()
            setShowSavingFilter(false)
        } catch (error) {
            props.showToastSaveFilterFailure()
        }
        props.doApplyFilter(getFilterForApi(localEditedFilter), true)
    }

    const onPressFilterItem = (filterSelected) => {
        if (!showSavingFilter) {
            setFilterCategorySelected(filterSelected)
        }
    }

    const onClickSave = () => {
        if (disabledSaveButtons) {
            props.showToastEmptyFilterWarning()
        } else {
            setShowConfirmModal(true)
        }
    }

    const onClickApply = () => {
        if (disabledSaveButtons && !localEditedFilter?.isOriginalFilter) {
            props.showToastEmptyFilterWarning(true)
            return
        }
        let existAlready = false
        let newFilter = { ...localEditedFilter }
        if (localEditedFilter?.isOriginalFilter) {
            existAlready = userFilters?.find((filter) => filter.isOriginalFilter) != undefined
        } else if (localEditedFilter?._id) {
            existAlready = true
        }
        newFilter = getFilterForApi(newFilter)
        const isSmartFilter: boolean = !!Object.keys(smartFilter || {}).length
        if (isSmartFilter) {
            doApplyFilter(getFilterFromSmartFilter(newFilter, smartFilter), existAlready)
            return
        }
        let hasFilter = false
        Object.keys(newFilter.categories.storeSpecs).forEach((filterKey) => {
            if (
                filterKey === 'store' &&
                newFilter.categories.storeSpecs[filterKey].length === storeIdList.length
            ) {
                hasFilter = hasFilter || false
                return
            }
            hasFilter = hasFilter || newFilter.categories.storeSpecs[filterKey].length > 0
        })
        if (!hasFilter) newFilter.categories.storeSpecs.store = []
        doApplyFilter(getFilterFromStoreFilter(newFilter, storeFilters), existAlready)
    }

    const reportTimes: { value: string; label: string }[] = [
        {
            value: 'none',
            label: intl.formatMessage({
                id: 'modals.filters.reports_timing.option.none',
                defaultMessage: 'None',
            }),
        },
        {
            value: 'last_week',
            label: intl.formatMessage({
                id: 'modals.filters.reports_timing.option.last_week',
                defaultMessage: 'Last week',
            }),
        },
        {
            value: 'last_month',
            label: intl.formatMessage({
                id: 'modals.filters.reports_timing.option.last_month',
                defaultMessage: 'Last month',
            }),
        },
        {
            value: 'last_year',
            label: intl.formatMessage({
                id: 'modals.filters.reports_timing.option.last_year',
                defaultMessage: 'Last year',
            }),
        },
        {
            value: 'current_week',
            label: intl.formatMessage({
                id: 'modals.filters.reports_timing.option.current_week',
                defaultMessage: 'Current week',
            }),
        },
        {
            value: 'current_month',
            label: intl.formatMessage({
                id: 'modals.filters.reports_timing.option.current_month',
                defaultMessage: 'Current month',
            }),
        },
        {
            value: 'current_year',
            label: intl.formatMessage({
                id: 'modals.filters.reports_timing.option.current_year',
                defaultMessage: 'Current year',
            }),
        },
        {
            value: 'year_to_date',
            label: intl.formatMessage({
                id: 'modals.filters.reports_timing.option.year_to_date',
                defaultMessage: 'Year to date',
            }),
        },
    ]

    const footer = isSavingFilterStep ? (
        <>
            <div className="smart-main-buttons saving-filter">
                <TextButton
                    onClick={handleClose}
                    label={intl.formatMessage({
                        id: 'modals.filters.label.cancel',
                        defaultMessage: 'Cancel',
                    })}
                />
                <RoundedButton
                    onClick={onClickSaveFilter}
                    disabled={!Boolean(localEditedFilter?.name)}
                    label={intl.formatMessage({
                        id: 'modals.filters.label.save_filter',
                        defaultMessage: 'Save Filter',
                    })}
                />
            </div>
        </>
    ) : showActionButtonIntoMainFooter ? (
        <>
            <div className="smart-main-buttons">
                <LuxButton
                    variant="text"
                    color={Color.PRIMARY}
                    onClick={onClickSave}
                    text={intl.formatMessage({
                        id: 'modals.filters.button.save',
                        defaultMessage: 'Save',
                    })}
                />
                <RoundedButton
                    onClick={onClickApply}
                    label={intl.formatMessage({
                        id: 'modals.filters.button.apply',
                        defaultMessage: 'Apply',
                    })}
                />
            </div>
        </>
    ) : null

    return (
        <div className="smart-modals-fullscreen with-header">
            <div className={componentClass}>
                <div className={`${componentClass}__header`}>
                    <Header onClose={() => handleClose()}>
                        <LuxBreadcrumb pathArray={activityBreadcrumb} />
                        <h1 className={`${componentClass}__header-mobile`}>
                            {showSavingFilter
                                ? intl.formatMessage({
                                      id: 'modals.filters.label.save_filter',
                                      defaultMessage: 'Save Filter',
                                  })
                                : filterCategorySelected === 'PROJECTS'
                                ? intl.formatMessage({
                                      id: 'modals.filters.label.projects',
                                      defaultMessage: 'Projects',
                                  })
                                : filterCategorySelected === 'STORE_SPECS'
                                ? intl.formatMessage({
                                      id: 'modals.filters.label.store_specs',
                                      defaultMessage: 'Store Specs',
                                  })
                                : filterCategorySelected === 'TIME_FRAME'
                                ? intl.formatMessage({
                                      id: 'modals.filters.label.time_frame',
                                      defaultMessage: 'Time Frame',
                                  })
                                : intl.formatMessage({
                                      id: 'modals.filters.breadcrumbs.filter',
                                      defaultMessage: 'Filter',
                                  })}
                        </h1>
                    </Header>
                </div>
                <div className={`${componentClass}__main`}>
                    {(isSelectCategoryStep || isCategorySelectedStep) && (
                        <>
                            {(isMobile && isCategorySelectedStep) || (
                                <div className={`${componentClass}__sidebar`}>
                                    <Sidebar>
                                        <ActiveFilters
                                            filters={userFilters}
                                            filterSelected={idFilterSelected}
                                            setFilterSelected={setIdFilterSelected}
                                            clearLocaleEditedFilter={clearLocaleEditedFilter}
                                        />
                                        <FilterCategories
                                            filterItems={filterItems}
                                            showSavingFilter={showSavingFilter}
                                        />
                                        <div className="smart-sidebar-buttons">
                                            <LuxButton
                                                text={intl.formatMessage({
                                                    id: 'modals.filters.button.save',
                                                    defaultMessage: 'Save',
                                                })}
                                                variant="text"
                                                color={Color.PRIMARY}
                                                onClick={onClickSave}
                                            />
                                            <RoundedButton
                                                label={intl.formatMessage({
                                                    id: 'modals.filters.button.apply',
                                                    defaultMessage: 'Apply',
                                                })}
                                                onClick={onClickApply}
                                            />
                                        </div>
                                    </Sidebar>
                                </div>
                            )}
                            {(isMobile && isSelectCategoryStep) || (
                                <div
                                    className={`${componentClass}__content ${
                                        !isSavingFilterStep && !showActionButtonIntoMainFooter
                                            ? 'full-height'
                                            : ''
                                    }`}>
                                    <MainContent
                                        footer={footer}
                                        hideFooter={
                                            !isSavingFilterStep && !showActionButtonIntoMainFooter
                                        }>
                                        <FilterSubCategories
                                            filterCategorySelected={filterCategorySelected}
                                            filterList={currentFilterCategoryList}
                                            localEditedFilter={localEditedFilter}
                                            changeEditedFilterField={changeEditedFilterField}
                                            reportTimes={reportTimes}
                                            selectedReportTime={selectedTimeCluster}
                                            onChangeReportsTiming={onChangeReportsTiming}
                                        />
                                    </MainContent>
                                </div>
                            )}
                        </>
                    )}
                    {isSavingFilterStep && (
                        <>
                            {isMobile || (
                                <div className={`${componentClass}__sidebar`}>
                                    <Sidebar>
                                        <FilterCategories
                                            filterItems={filterItemsSummary}
                                            showSavingFilter={showSavingFilter}
                                        />
                                        <div className="smart-sidebar-buttons"></div>
                                    </Sidebar>
                                </div>
                            )}
                            <div className={`${componentClass}__content`}>
                                <MainContent footer={footer}>
                                    <SavingFilters
                                        filterItems={filterItemsSummary}
                                        nameFilter={localEditedFilter?.name}
                                        setNameFilter={(nameFilter) =>
                                            changeEditedFilterField(nameFilter, 'name')
                                        }
                                        isDefault={localEditedFilter?.isDefault}
                                        setIsDefault={(value) => {
                                            changeEditedFilterField(value, 'isDefault')
                                        }}
                                    />
                                </MainContent>
                            </div>
                        </>
                    )}
                </div>
            </div>
            {showConfirmModal && (
                <CardModal onClose={() => setShowConfirmModal(false)}>
                    <div className="confirm-modal-container">
                        <h3>
                            {intl.formatMessage({
                                id: 'modals.filters.label.saving_options',
                                defaultMessage: 'Saving Options',
                            })}
                        </h3>
                        <p>
                            {intl.formatMessage({
                                id: 'modals.filters.label.how_do_you_want_to_save_your_filters',
                                defaultMessage: 'How do you want to save your Filter?',
                            })}
                        </p>
                        <div className="buttons-container">
                            <OutlinedButton
                                label={intl.formatMessage({
                                    id: 'modals.filters.label.save_as_new',
                                    defaultMessage: 'Save as New',
                                })}
                                onClick={() => {
                                    setShowConfirmModal(false)
                                    setShowSavingFilter(true)
                                }}
                            />
                            <RoundedButton
                                label={intl.formatMessage({
                                    id: 'modals.filters.label.update',
                                    defaultMessage: 'Update',
                                })}
                                onClick={() => {
                                    setShowConfirmModal(false)
                                    onClickUpdateFilter()
                                }}
                            />
                        </div>
                    </div>
                </CardModal>
            )}
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    userFilters: state.filtersReducer?.filtersList ?? [],
    user: state.userReducer?.user ?? [],
    subtypes: state[FILTERS_REDUCER_NAMESPACE]?.subtypes ?? {},
    departmentList: state[FILTERS_REDUCER_NAMESPACE]?.departmentList ?? [],
    storesOptionList: state[FILTERS_REDUCER_NAMESPACE]?.storesOptionList ?? [],
    storeIdList: state[FILTERS_REDUCER_NAMESPACE]?.storeIdList ?? [],
    statusOptionList: state[FILTERS_REDUCER_NAMESPACE]?.statusOptionList ?? [],
    projectTypeOption: state[FILTERS_REDUCER_NAMESPACE]?.projectTypeOption ?? {},
    activityTypes: state[FILTERS_REDUCER_NAMESPACE]?.activityTypes,
    prioritiesOptionList: state[FILTERS_REDUCER_NAMESPACE]?.prioritiesOptionList ?? [],
    recipientList: state[FILTERS_REDUCER_NAMESPACE]?.recipientList ?? [],
    selectedTimeCluster: state[FILTERS_REDUCER_NAMESPACE]?.selectedTimeCluster,
    filtersOptionsMap: state[DISTRIBUTION_REDUCER_NAMESPACE]?.filtersOptionsMap,
    macroareas:
        state[FILTERS_REDUCER_NAMESPACE]?.macroareas?.map((m) => ({ value: m, label: m })) ?? [],
    photoStatusList:
        state[FILTERS_REDUCER_NAMESPACE]?.photoStatusList?.map((p) => ({ value: p, label: p })) ??
        [],
    banner: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].banner,
})

const mapDispatchToProps = (dispatch: any) => ({
    setSelectedTimeCluster: (val: string) => dispatch(setSelectedTimeCluster(val)),
    closeFilters: () => {
        dispatch(layoutActions.setModals({ type: null }))
    },
    getFilters: () => {
        dispatch(filtersActions.loadFilterList())
    },
    getFiltersDomain: (callback: () => void) => {
        dispatch(getFiltersDomain(callback))
    },
    getDepartments: () => {
        dispatch(getDepartments())
    },
    getAllSubtypes: () => {
        dispatch(getAllSubtypes())
    },
    getFiltersActivityTypes: (params) => {
        dispatch(getFiltersActivityTypes(params))
    },
    getFilterStatusOptions: () => {
        dispatch(getActivityFiltersOptions())
    },
    getRecipients: () => {
        dispatch(getRecipients())
    },
    showToastEmptyFilterWarning: (isApplyMessage: boolean) => {
        dispatch(showToastEmptyFilterWarning(isApplyMessage))
    },
    showToastSaveFilterSuccess: () => {
        dispatch(showToastSaveFilterSuccess())
    },
    showToastSaveFilterFailure: () => {
        dispatch(showToastSaveFilterFailure())
    },
    doApplyFilter: (filter: Filter, existAlready: boolean) =>
        dispatch(doApplyFilter(filter, existAlready)),
    setLoading: (loading) => dispatch(layoutActions.setModals({ props: { loading } })),
    getReportTimes: () => {
        dispatch(getReportTimes())
    },
    getMacroareas: (banner: string[]) => dispatch(getMacroareas(banner)),
    getPhotoStatusList: () => dispatch(getPhotoStatusList()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Filters)
